import getRoomAvailabilityStore from '../store/roomAvailabilityStore';
import type { RoomRecurrenceAvailability } from '../store/schema/RoomAvailabilityState';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export default function getRecurrenceRoomsAvailabilitiesState(event: CalendarEvent) {
    let totalInstancesCount: number = 0;
    let availableInstancesCount: number = 0;
    event.Resources.forEach(room => {
        const availability = getRecurrenceRoomAvailability(room.Mailbox.EmailAddress);
        if (availability) {
            totalInstancesCount += availability.totalInstancesCount;
            availableInstancesCount += availability.availableInstancesCount;
        }
    });

    return {
        totalInstances: totalInstancesCount,
        freeInstancesCount: availableInstancesCount,
    };
}

function getRecurrenceRoomAvailability(smtpAddress: string): RoomRecurrenceAvailability {
    const roomAvailabilityStates = getRoomAvailabilityStore().roomAvailabilityStates;
    if (roomAvailabilityStates) {
        const roomAvailabilityState = roomAvailabilityStates.get(smtpAddress);
        if (roomAvailabilityState) {
            return roomAvailabilityState.roomRecurrenceAvailability;
        }
    }

    return null;
}
